var showOrHideInit = function () {
    var linksToShowAndHide = {
        linksToShow: $("a[data-show]"),
        linksToHide: $("a[data-hide]")
    },
    handler = function (requestType, e) {
         if (e.type == "keypress" && e.which != 32 && e.which != 1)
             return;

         var _self = $(this),
             eleToShow = $('[data-id=' + _self.data("show") + ']'),
             eleToShowParent = eleToShow.parent(),
             eleToHide = $('[data-id=' + _self.data("hide") + ']'),
             eleToHideParent = eleToHide.parent();

         if (requestType == "linksToShow") {
             var finalEleToShow = eleToShow;
             if (eleToShowParent.is(".custom-select")) {
                 finalEleToShow = finalEleToShow.add(eleToShowParent);
             }
             finalEleToShow.each(function () {
                 $(this).removeClass('visually-hidden x hide').
                 attr("aria-hidden", "false");
             });
             eleToShow.on('focus');
         }
         else {
             var finalEleToHide = eleToHide;
             if (eleToHideParent.is(".custom-select")) {
                 var finalEleToHide = finalEleToHide.add(eleToHideParent);
             }
             finalEleToHide.each(function () {
                 $(this).addClass('visually-hidden').
                 attr("aria-hidden", "true");
             })
         }
         return false;
     };

    for (i in linksToShowAndHide)
        linksToShowAndHide[i].each(function () {
            $(this).on({ click: handler.on(this, i), keypress: handler.on(this, i) });
        });
};